import { createTheme } from "@mui/material/styles";

/** Farbpalette aus der Vorgängerfassung übernommen. */
export const theme = createTheme({
  colorSchemes: { light: true, dark: true },
  palette: {
    primary: { main: "#4f5396", dark: "#1e2b68", light: "#7f7fc7" },
    secondary: { main: "#6281d6", dark: "#2a55a4", light: "#96b0ff" },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
  },
});
